import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { postSagepayProcess } from 'src/api/sagepay/requests';
import { SagepayProcessResponse } from 'src/api/sagepay/types';

export const usePostSagepayProcess = () =>
    useMutation<SagepayProcessResponse, AxiosError, string>({
        mutationFn: (basketId: string) => postSagepayProcess(basketId),
    });
